// Exact Figma export (Lucide, 2px stroke on a 16px grid). Stroke colour is a prop.
function PaywallShield({ dimensions, col = '#fff' }) {
  return `
    <svg width=${dimensions || '16'} height=${dimensions || '16'} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.22664 14.6335C10.9997 13.6668 13.3328 12.0001 13.3328 8.66667V3.99985C13.3328 3.82304 13.2626 3.65346 13.1376 3.52843C13.0125 3.4034 12.843 3.33316 12.6662 3.33316C11.333 3.33316 9.67317 2.53981 8.50662 1.51977C8.36539 1.3991 8.18575 1.3328 8 1.3328C7.81425 1.3328 7.63461 1.3991 7.49338 1.51977C6.3335 2.53314 4.667 3.33316 3.3338 3.33316C3.15701 3.33316 2.98745 3.4034 2.86244 3.52843C2.73743 3.65346 2.6672 3.82304 2.6672 3.99985V8.66667C2.6672 12.0001 5.0003 13.6668 7.78002 14.6269C7.9237 14.6804 8.08143 14.6827 8.22664 14.6335Z" stroke="${col}" stroke-width="2" stroke-linecap="round"/>
    </svg>
  `;
}

export default PaywallShield;
